import { Payment } from "@b2bportal/purchase-api";
import {
  type AirPriceFreezeMachineContext,
  cartHelpers,
  getObjectKeysAsObject,
} from "@hopper-b2b/checkout";
import { assign } from "xstate";
import type { IUberPayment } from "../../types";
import { PaymentState, type UberPaymentContext } from "./context";
import type { SetPaymentDataAndGoNext } from "./events";

export const paymentActions = {
  setPaymentData: assign(
    (
      ctx: AirPriceFreezeMachineContext<UberPaymentContext>,
      event: SetPaymentDataAndGoNext
    ) => {
      ctx[PaymentState.payment].paymentSessionToken = event.paymentSessionToken;
      ctx[PaymentState.payment].paymentQuoteToken = event.paymentQuoteToken;

      const payment: IUberPayment = {
        type: Payment.UberPayment,
        value: {
          encryptedQuoteToken: event.paymentQuoteToken.value,
          paymentSessionToken: event.paymentSessionToken,
        },
      };

      return cartHelpers.addFulfillPayment(payment, ctx);
    }
  ),
};

export const ActionTypes = getObjectKeysAsObject(paymentActions);
